/* eslint-disable max-len */
import React from 'react'
import DashBoardLineIcon from 'remixicon-react/DashboardLineIcon'
import DashBoardFillIcon from 'remixicon-react/DashboardFillIcon'
import FundsLineIcon from 'remixicon-react/FundsLineIcon'
import FundsFillIcon from 'remixicon-react/FundsFillIcon'
import LeafLineIcon from 'remixicon-react/LeafLineIcon'
import LeafFillIcon from 'remixicon-react/LeafFillIcon'
import BankCardLineIcon from 'remixicon-react/BankCardLineIcon'
import BankCardFillIcon from 'remixicon-react/BankCardFillIcon'
import FileCopyLineIcon from 'remixicon-react/FileCopy2LineIcon'
import FileCopyFillIcon from 'remixicon-react/FileCopy2FillIcon'
import BuildingLineIcon from 'remixicon-react/BuildingLineIcon'
import BuildingFillIcon from 'remixicon-react/BuildingFillIcon'
import UserLineIcon from 'remixicon-react/UserLineIcon'
import UserFillIcon from 'remixicon-react/UserFillIcon'
import TeamLineIcon from 'remixicon-react/TeamLineIcon'
import TeamFillIcon from 'remixicon-react/TeamFillIcon'
import PriceTagLineIcon from 'remixicon-react/PriceTag2LineIcon'
import PriceTagFillIcon from 'remixicon-react/PriceTag2FillIcon'
import GlobeLineIcon from 'remixicon-react/GlobeLineIcon'
import GlobeFillIcon from 'remixicon-react/GlobeFillIcon'
import GroupLineIcon from 'remixicon-react/GroupLineIcon'
import GroupFillIcon from 'remixicon-react/GroupFillIcon'
import ParentLineIcon from 'remixicon-react/ParentLineIcon'
import ParentFillIcon from 'remixicon-react/ParentFillIcon'
import FileList3LineIcon from 'remixicon-react/FileList3LineIcon'
import FileList3FillIcon from 'remixicon-react/FileList3FillIcon'
import SurveyLineIcon from 'remixicon-react/SurveyLineIcon'
import SurveyFillIcon from 'remixicon-react/SurveyFillIcon'
import {
  CoinLeaf, CoinLeafFill, FileLeaf, FileLeafFill, BillDollar,
} from '../icons'
import {
  VIEW_TITULOS_LBC, VIEW_CLIENT, VIEW_ADMIN, VIEW_AUDITOR, TIPO_USUARIO,
} from '../../utils/constantes'

export const userItems = [
  {
    groupLabel: 'menuItems.inicio',
    items: [
      {
        label: 'menuItems.visaoGeral',
        to: '/dashboard',
        icon: <DashBoardLineIcon />,
        activeIcon: <DashBoardFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.avaliacao',
    items: [
      {
        label: 'menuItems.pressaoBiodiversidade',
        to: '/pressaoBiodiversidade',
        icon: <FundsLineIcon />,
        activeIcon: <FundsFillIcon />,
      },
      {
        label: 'menuItems.desempenhoBiodiversidade',
        icon: <LeafLineIcon />,
        activeIcon: <LeafFillIcon />,
        subMenus: [
          {
            label: 'menuItems.desempenho',
            to: '/desempenhoBiodiversidade',
            icon: <FileLeaf />,
            activeIcon: <FileLeafFill />,
          },
          {
            label: 'menuItems.creditosBiodiversidade',
            to: '/desempenhoBiodiversidade/creditos-biodiversidade',
            icon: <CoinLeaf />,
            activeIcon: <CoinLeafFill />,
          },
          {
            label: 'menuItems.gestaoTitulosCredito',
            to: '/titulos-lbc',
            icon: <BillDollar />,
            activeIcon: <BillDollar />,
            requiredPermissions: VIEW_TITULOS_LBC,
          },
        ],
      },
      {
        label: 'menuItems.indicadoresGestao',
        to: '/indicadoresGestao',
        icon: <BankCardLineIcon />,
        activeIcon: <BankCardFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.relatorios',
    items: [
      {
        label: 'menuItems.relatorios',
        to: '/relatorios',
        icon: <FileCopyLineIcon />,
        activeIcon: <FileCopyFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.auditoria',
    items: [
      {
        label: 'menuItems.planoAuditoria',
        to: '/secaoAuditoria',
        icon: <FileList3LineIcon />,
        activeIcon: <FileList3FillIcon />,
      },
      {
        label: 'menuItems.parecerAuditoria',
        to: '/parecerAuditoria',
        icon: <SurveyLineIcon />,
        activeIcon: <SurveyFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.configuracoes',
    items: [
      {
        label: 'menuItems.minhaEmpresa',
        to: '/dadosEmpresa',
        icon: <BuildingLineIcon />,
        activeIcon: <BuildingFillIcon />,
      },
      {
        label: 'menuItems.meuPerfil',
        to: '/meuPerfil',
        icon: <UserLineIcon />,
        activeIcon: <UserFillIcon />,
      },
    ],
  },
]

export const adminItems = [
  {
    groupLabel: 'menuItemsAdm.contas',
    items: [
      {
        label: 'menuItemsAdm.empresas',
        to: '/adm/empresas',
        icon: <BuildingLineIcon />,
        activeIcon: <BuildingFillIcon />,
      },
      {
        label: 'menuItemsAdm.usuarios',
        to: '/adm/usuarios',
        icon: <TeamLineIcon />,
        activeIcon: <TeamFillIcon />,
      },
      {
        label: 'menuItemsAdm.licencas',
        to: '/adm/licencas',
        icon: <PriceTagLineIcon />,
        activeIcon: <PriceTagFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItemsAdm.auditoria',
    items: [
      {
        label: 'menuItemsAdm.auditores',
        to: '/adm/auditores',
        icon: <ParentLineIcon />,
        activeIcon: <ParentFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItemsAdm.configuracoes',
    items: [
      {
        label: 'menuItemsAdm.paisesCalculos',
        to: '/adm/paisesCalculos',
        icon: <GlobeLineIcon />,
        activeIcon: <GlobeFillIcon />,
      },
      {
        label: 'menuItemsAdm.usuariosLife',
        to: '/adm/usuariosLife',
        icon: <GroupLineIcon />,
        activeIcon: <GroupFillIcon />,
      },
    ],
  },
]

export const auditorItems = [
  {
    groupLabel: 'menuItems.inicio',
    items: [
      {
        label: 'menuItems.auditorias',
        to: '/auditorias',
        icon: <ParentLineIcon />,
        activeIcon: <ParentFillIcon />,
      },
    ],
  },
  {
    groupLabel: 'menuItems.configuracoes',
    items: [
      {
        label: 'menuItems.meuPerfil',
        to: '/auditoria/meuPerfil',
        icon: <UserLineIcon />,
        activeIcon: <UserFillIcon />,
      },
    ],
  },
]

// Gerente de Crédito é um perfil global (sem empresa): vê apenas o módulo de Créditos LBC.
export const gerenteItems = [
  {
    groupLabel: 'menuItems.creditos',
    items: [
      {
        label: 'menuItems.titulosLbc',
        to: '/titulos-lbc',
        icon: <CoinLeaf />,
        activeIcon: <CoinLeafFill />,
      },
      {
        label: 'menuItems.resgatesLbc',
        to: '/resgates-lbc',
        icon: <FundsLineIcon />,
        activeIcon: <FundsFillIcon />,
      },
    ],
  },
]

// Observador de Créditos: perfil global (sem empresa) somente-leitura — vê Títulos LBC e Resgates.
export const observadorCreditoItems = [
  {
    groupLabel: 'menuItems.creditos',
    items: [
      {
        label: 'menuItems.titulosLbc',
        to: '/titulos-lbc',
        icon: <CoinLeaf />,
        activeIcon: <CoinLeafFill />,
      },
      {
        label: 'menuItems.resgatesLbc',
        to: '/resgates-lbc',
        icon: <FundsLineIcon />,
        activeIcon: <FundsFillIcon />,
      },
    ],
  },
]

// Seleciona o conjunto de menu conforme o perfil e filtra itens por requiredPermissions.
export const menuParaUsuario = (userId) => {
  let base = []
  if (userId === TIPO_USUARIO.CLIENTE.GERENTE_CREDITO) base = gerenteItems
  else if (userId === TIPO_USUARIO.CLIENTE.OBSERVADOR_CREDITO) base = observadorCreditoItems
  else if (VIEW_CLIENT.includes(userId)) base = userItems
  else if (VIEW_ADMIN.includes(userId)) base = adminItems
  else if (VIEW_AUDITOR.includes(userId)) base = auditorItems

  const liberado = (entry) => !entry.requiredPermissions || entry.requiredPermissions.includes(userId)
  const filtrarSubMenus = (item) => (item.subMenus
    ? { ...item, subMenus: item.subMenus.filter(liberado) }
    : item)
  return base
    .filter(liberado)
    .map((group) => ({ ...group, items: group.items.filter(liberado).map(filtrarSubMenus) }))
    .filter((group) => group.items.length > 0)
}
